import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';
import type { WithAnalyticsEventsProps } from '@atlaskit/analytics-next/withAnalyticsEvents';
import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { RefAttributes } from 'react';
import type {
	EditorBreadcrumbsProps,
	EditorBreadcrumbActions,
	EditorBreadcrumbOwnProps,
} from './breadcrumbTypes.ts';

export const EditorBreadcrumbs: LoadableType<
	Omit<
		EditorBreadcrumbsProps &
			EditorBreadcrumbActions &
			EditorBreadcrumbOwnProps & {
				createAnalyticsEvent: CreateUIAnalyticsEvent;
			},
		keyof WithAnalyticsEventsProps
	> &
		RefAttributes<any>
> = LoadableAfterPaint({
	loader: async () => {
		const { EditorBreadcrumbsComponent } = await import(
			/* webpackChunkName: "loadable-EditorBreadcrumbs" */ '../src/EditorBreadcrumbs.tsx'
		);
		return EditorBreadcrumbsComponent;
	},
});
